import { render, staticRenderFns } from "./SaveAllData.vue?vue&type=template&id=07c69fcf&scoped=true&"
import script from "./SaveAllData.vue?vue&type=script&setup=true&lang=js&"
export * from "./SaveAllData.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SaveAllData.vue?vue&type=style&index=0&id=07c69fcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c69fcf",
  null
  
)

export default component.exports